module.exports = __webpack_public_path__ + "static/img/0-1home.e3c820c3.jpg";